export const download = async (response, fileName) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([response]));
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}
